import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../app/shared/Strings');

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: '',
}


function SkillBuildLogo(props) {
    return (
        <img
            className={`skillbuild-logo ${props.className}`}
            src={`${GlobalConfig.StaticUrl}/img/SkillBuildLogo_Navy.svg`}
            alt={Strings['en'].common.SKILLBUILD}
        />
    );
}

SkillBuildLogo.propTypes = propTypes;
SkillBuildLogo.defaultProps = defaultProps;

export default SkillBuildLogo;